import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import { getTable } from "../../../../Services/tooltipService";
import DataTable from "../../../../Components/UiComponents/DataTable";
import Loader from "../../../../Components/UiComponents/Loader";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { getTimesheet, generateTimesheet } from "../../../../Services/opportunityService";
import TimesheetExcelUploader from "./TimesheetExcelUploader";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";

const Timesheet = (props) => {
    const [loading, setLoading] = useState(false);
    const [timeSheetTables, setTimeSheetTables] = useState([]);
    const [timeSheetHeadings, setTimeSheetHeadings] = useState([]);
    const [timesheet, setTimesheet] = useState([]);
    const [uploadTimesheet, setUploadTimesheet] = useState(false);
    const navigate = useNavigate()

    var enduser = localStorage.getItem("enduser");
    if (enduser) {
        var tmpData = JSON.parse(enduser);
        if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
    }

    const toastRef = useRef();

    useEffect(() => {
        getTimesheetDetails(tmpData.userid, 'All')
        getTimesheetTables()
    }, []);

    const getTimesheetTables = async () => {
        try {
            if (tmpData === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            var fieldData = await getTable(tmpData.customer)
            if (fieldData && fieldData?.data) {
                var myAccModuleDataTables = fieldData.data;
                var myaccFieldsTable = _.find(myAccModuleDataTables.cust[0].modules, { module_name: "My Account", status: true });
                var timeSheetTables = _.find(myaccFieldsTable.sub_modules, { sub_module_name: "Time Sheet" }).tables;
                setTimeSheetTables(timeSheetTables);
                var timeSheetHeadings = _.find(timeSheetTables, { table_name: "TimeSheet" }).headers;
                setTimeSheetHeadings(timeSheetHeadings);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const idTemplate = (rowData, index) => {
        return index.rowIndex + 1;
    }

    const columns = [
        {
            field: "id",
            header: _.find(timeSheetHeadings, { header_name: "#" })?.display_name,
            body: idTemplate,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "opportunity_seq",
            header: _.find(timeSheetHeadings, { header_name: "Project Id" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "opportunity_name",
            header: _.find(timeSheetHeadings, { header_name: "Project" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "team_member",
            header: _.find(timeSheetHeadings, { header_name: "Team Member" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "bid_team_role",
            header: _.find(timeSheetHeadings, { header_name: "Bid Team Role" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "total_est_hours",
            header: _.find(timeSheetHeadings, { header_name: "Est Hours" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "total_actual",
            header: _.find(timeSheetHeadings, { header_name: "Actual Hours to Date" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "actual_to_date",
            header: _.find(timeSheetHeadings, { header_name: "Last Updated Date" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        }
    ]

    const getTimesheetDetails = async (userId, oppId) => {
        try {
            if (tmpData === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true)
            var timesheet = [];
            var timesheetData = await getTimesheet(tmpData.customer, userId, oppId)
            if (timesheetData && timesheetData.data) {
                timesheet = timesheetData.data.opps;
                setTimesheet(timesheet)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    };

    const uploadTimesheetData = () => {
        setUploadTimesheet(true)
    }

    const onCloseUploadPopup = () => {
        setUploadTimesheet(false);
    };

    const attachedData = (data) => {
        if (data) {
            getTimesheetDetails(tmpData.userid, 'All');
        }
    }

    const generateTimesheetData = async () => {
        if (!_.isEmpty(timesheet)) {
            try {
                // Filter and process the timesheet data
                const processedTimesheet = timesheet.map((record) => {
                    if (record.total_actual === undefined) {
                        record.total_actual = '';
                    }
                    if (record.actual_to_date === undefined) {
                        record.actual_to_date = '';
                    }
                    return record;
                });

                const username = tmpData.firstname + " " + tmpData.surname;

                const response = await generateTimesheet(JSON.stringify(processedTimesheet), username);
            } catch (error) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'An error occurred. Please try again or Contact Admin.'
                });
            }
        } else {
            toastRef.current.showToast({
                type: "info",
                message: "No Timesheet Available",
            });
        }
    };

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="data-submit mt-10">
                {
                    _.find(timeSheetTables, { table_name: "TimeSheet" })?.status &&
                    <DataTable
                        value={timesheet}
                        columns={columns}
                        dataSubmitted={true}
                        header={true}
                        headerName={true}
                        headingName={_.find(timeSheetTables, { table_name: "TimeSheet" })?.display_name}
                        paginator={true}
                    />
                }
            </div>
            <div className="col pr-0 d-flex justify-end mt-10">
                {/* <ButtonElement label="Import" className="cancel-new-button" onClick={() => uploadTimesheetData()} /> */}
                <ButtonElement className="save-button" type="submit" onClick={generateTimesheetData} label="Export" />
            </div>
            <Dialog
                header={"Upload File"}
                visible={uploadTimesheet}
                position="top"
                className='width-50vw'
                onHide={onCloseUploadPopup}
                draggable={false}
            >
                <TimesheetExcelUploader
                    onCloseUploadPopup={onCloseUploadPopup}
                    customerId={tmpData.customer}
                    attachedData={attachedData}
                />
            </Dialog>
        </div>
    );
}

export default Timesheet;
